import { render, staticRenderFns } from "./verDocumentos.vue?vue&type=template&id=459751ae&"
import script from "./verDocumentos.vue?vue&type=script&lang=js&"
export * from "./verDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./verDocumentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports